// markdownParser.ts

import MarkdownIt from 'markdown-it';

export default new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});
